import { __awaiter } from '../_virtual/_tslib.js';
import { toast } from '../components/toast/toast.js';

const BASE_URL = "https://careers-app.vahak.in/ghost/api/v3/content";
const KEY = process.env.NEXT_PUBLIC_REACT_APP_CAREERS_KEY || process.env.REACT_APP_CAREERS_KEY;
const CATEGS_URL = `${BASE_URL}/tags`;
const JOBS_URL = `${BASE_URL}/posts`;
const JobDetailsFieldsQuery = `fields=title%2Chtml%2Cupdated_at%2Ccustom_excerpt%2Ccanonical_url`;
const AllJobsDetailsFieldsQuery = `fields=title%2Cslug%2Ccustom_excerpt`;
function getAllCategories() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${CATEGS_URL}?key=${KEY}&fields=name%2Cslug`, {
                method: "GET"
            }));
            if (call.status === 200) {
                const { tags } = yield call.json();
                return { categs: tags };
            }
        }
        catch (e) {
            toast.error("An error occured, please try again after sometime");
        }
        return { categs: null };
    });
}
function getAllJobs({ page = 1, limit = 6 }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${JOBS_URL}?key=${KEY}&${AllJobsDetailsFieldsQuery}&page=${page}&limit=${limit}`, {
                method: "GET"
            }));
            if (call.status === 200) {
                const { posts, meta } = yield call.json();
                return { jobs: posts, meta };
            }
        }
        catch (e) {
            toast.error("An error occured, please try again after sometime");
        }
        return { jobs: null, meta: null };
    });
}
function getJobsByCateg({ page = 1, limit = 6, categSlug }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${JOBS_URL}?key=${KEY}&${AllJobsDetailsFieldsQuery}&page=${page}&limit=${limit}&filter=tag:${categSlug}`, { method: "GET" }));
            if (call.status === 200) {
                const { posts, meta } = yield call.json();
                return { jobs: posts, meta };
            }
        }
        catch (e) {
            toast.error("An error occured, please try again after sometime");
        }
        return { jobs: null, meta: null };
    });
}
function getJobBySlug({ slug }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${JOBS_URL}/slug/${slug}?key=${KEY}&${JobDetailsFieldsQuery}`), {
                method: "GET"
            });
            if (call.status === 200) {
                return (yield call.json()).posts[0];
            }
        }
        catch (e) {
            toast.error("An error occured, please try again after sometime");
        }
        return null;
    });
}
const CareersService = { getAllCategories, getAllJobs, getJobsByCateg, getJobBySlug };

export { CareersService };
//# sourceMappingURL=careers.service.js.map
